var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77 14.611s5.52-3.818 5.52-8.273a5.837 5.837 0 0 0-1.616-4.05A5.423 5.423 0 0 0 5.769.612 5.423 5.423 0 0 0 1.865 2.29a5.838 5.838 0 0 0-1.617 4.05c0 4.454 5.521 8.272 5.521 8.272Zm1.84-8.273c0 1.055-.825 1.91-1.841 1.91-1.017 0-1.84-.855-1.84-1.91 0-1.054.823-1.909 1.84-1.909 1.016 0 1.84.855 1.84 1.91Z",
    fill: "#fff"
  })));
};
export default SvgLocation;